/*
 * @Author:
 * @Date: 2021-04-01 16:36:55
 * @Description:
 */
/*
 * @Author: dongzhuo
 * @Description: 常量
 */
import API from "./api";

export default {
  install(Vue) {
    Vue.prototype.$common = {
      sexOptions: [
        {
          key: "0",
          value: "保密",
        },
        {
          key: "1",
          value: "男",
        },
        {
          key: "2",
          value: "女",
        },
      ],
      enabelOptions: [
        {
          key: true,
          value: "启用",
        },
        {
          key: false,
          value: "禁用",
        },
      ],
      resultOptions: [
        {
          key: true,
          value: "成功",
        },
        {
          key: false,
          value: "失败",
        },
      ],
      flagOptions: [
        {
          key: true,
          value: "是",
        },
        {
          key: false,
          value: "否",
        },
      ],
      releaseOptions: [
        {
          key: "no",
          value: "未发布",
        },
        {
          key: "already",
          value: "已发布",
        },
        {
          key: "offShelf",
          value: "已下架",
        },
        {
          key: "disabled",
          value: "已失效",
        },
      ],
      //
      sexList: [
        { key: 0, value: "保密" },
        { key: 1, value: "男" },
        { key: 2, value: "女" },
      ],
      // 工作状态
      workState: [
        { key: "在校", value: "在校" },
        { key: "在职", value: "在职" },
        { key: "离职办理中", value: "离职办理中" },
        { key: "离职找工作中", value: "离职找工作中" },
      ],
      // 婚姻状态
      marriageState: [
        { key: "未婚", value: "未婚" },
        { key: "已婚", value: "已婚" },
        { key: "离异", value: "离异" },
      ],
      // 政治面貌
      identityState: [
        { key: "团员", value: "团员" },
        { key: "党员", value: "党员" },
        { key: "无党派人士", value: "无党派人士" },
        { key: "其他党派人士", value: "其他党派人士" },
      ],
      // 学历
      degrees: [
        { value: "0", label: "初中及以下", },
        { value: "1", label: "高中", },
        { value: "2", label: "中专/中技", },
        { value: "3", label: "大专", },
        { value: "4", label: "本科", },
        { value: "5", label: "硕士", },
        { value: "6", label: "MBA/EMBA", },
        { value: "7", label: "博士", },
      ],
      // 语言熟练
      langColors: [
        { color: '#909399', percentage: 10 },
        { color: '#F56C6C', percentage: 40 },
        { color: '#E6A23C', percentage: 70 },
        { color: '#67C23A', percentage: 100 }
      ],
      langSelectOptions: [
        { key: 10, value: "一般" },
        { key: 40, value: "良好" },
        { key: 70, value: "熟练" },
        { key: 100, value: "精通" },
      ],
      langShowOptions: {
        10: "一般",
        40: "良好",
        70: "熟练",
        100: "精通",
      },
    };
    /**
     * 接口
     */
    Vue.prototype.$api = {
      ...API
    };
  },
};
